import BaseService from '../baseServices';
import REST from '../../configs/rest';

function postPayrollEmployee({ body, id }) {
  return BaseService.post(REST.PAYROLL_EMPLOYEE(id), body);
}

function postImportPayroll({ body }) {
  return BaseService.post(REST.PAYROLL_IMPORT, body);
}

function getExportPayroll({ params }) {
  let q = `start=${params?.start}&end=${params?.end}`;
  if (params?.holiday) {
    const parsedHoliday = params?.holiday
      .map((item) => {
        return `"${item}"`;
      })
      .join(',');
    q = `holiday=[${parsedHoliday}]&${q}`;
  }
  return `${REST.PAYROLL_EXPORT}?${q}`;
  // return BaseService.get(`${REST.PAYROLL_EXPORT}?${q}`);
}

function getPayrollEmployee({ id, params }) {
  let q = `start=${params?.start}&end=${params?.end}`;
  if (params?.holiday) {
    const parsedHoliday = params?.holiday
      .map((item) => {
        return `"${item}"`;
      })
      .join(',');
    q = `holiday=[${parsedHoliday}]&${q}`;
  }
  return BaseService.get(`${REST.PAYROLL_EMPLOYEE(id)}?${q}`);
}

function getPayrollEmployeeComplete({ id, params }) {
  let q = `start=${params?.start}&end=${params?.end}`;
  if (params?.holiday) {
    const parsedHoliday = params?.holiday
      .map((item) => {
        return `"${item}"`;
      })
      .join(',');
    q = `holiday=[${parsedHoliday}]&${q}`;
  }
  return BaseService.get(`${REST.PAYROLL_EMPLOYEE_COMPLETE(id)}?${q}`);
}

export default {
  postImportPayroll,
  postPayrollEmployee,
  getPayrollEmployee,
  getPayrollEmployeeComplete,
  getExportPayroll,
};
